import { ProductAnalyticsEvents } from "../enum/ProductAnalyticsEvents";
import posthog from "posthog-js";
import api from "./api";

export default class LogService {
  async addProductAnalyticsEvent(
    productAnalyticsEvent: ProductAnalyticsEvents,
    eventProperty?: Record<string, any>
  ) {
    const response = await api.post(`/v1/log/AddProductAnalyticsEvent`, {
      productAnalyticsEvent,
      eventProperty,
    });
    return response.data;
  }

  async identifyUser(userId: string, userData?: any) {
    try {
      posthog.identify(userId, userData);
    } catch (error) {
      console.log(error);
    }
  }
}
